import React, { useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { colorList } from 'utils/colors'
import QRCode from 'react-native-qrcode-svg'
import _ from 'lodash'
import HelperString from 'utils/helper-string'

const ThemedQrCode = ({ value, size, color = colorList.BLACK.primary, backgroundColor = colorList.WHITE.primary, ...props }) => {
	
	const [ viewWidth, setViewWidth ] = useState( _.isInteger( size ) ? size : null )
	
	return (
		<View
			style={[
				styles.container,
				viewWidth !== null ? { height: viewWidth, flexBasis: viewWidth } : null,
			]}
			onLayout={ event => {
				const { width, } = event.nativeEvent.layout;
				
				let newWidth;
				switch( true ) {
					case typeof size === 'undefined':
						newWidth = width;
						break;
					
					case _.isString( size ) && _.endsWith( size, '%' ):
						newWidth = ( width / 100 ) * parseInt( size );
						break;
						
					default:
						newWidth = size > width ? width : size;
				}
				
				// Add a min width
				if( isNaN( newWidth ) || newWidth < 10 ) {
					newWidth = 10;
				}
				
				// Only update when different
				if( newWidth !== viewWidth ) {
					setViewWidth( newWidth )
				}
			}}>
			
			{ typeof viewWidth !== 'undefined' && viewWidth !== null &&
				<QRCode
					{ ...props }
					key={ HelperString.hash('qr-code', viewWidth ) }
					value={ value }
					size={ viewWidth }
					color={ color }
					backgroundColor={ backgroundColor }
				/>
			}
		</View>
	)
}

const styles = StyleSheet.create({
	container: {
		width: '100%',
		flexGrow: 0,
		flexShrink: 0,
		alignItems: 'center',
		justifyContent: 'center',
	}
})

export default ThemedQrCode
